import { styled } from '@mui/material/styles';
import Container from '../atoms/Container';

export const DetailsContainer = styled(Container)`
  margin-top: 20px;
`;
